import { render } from "./navbar-content.vue?vue&type=template&id=2b826f99"
import script from "./navbar-content.vue?vue&type=script&lang=js"
export * from "./navbar-content.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__